import { useEffect, useState } from "react";

const USE_TIPS = "dimensions-use-tips";

const getUseTips = () => JSON.parse(localStorage.getItem(USE_TIPS)) || false;

export const useTips = () => {
    const [showTips, setShowTips] = useState(getUseTips);

    useEffect(() => {
        const initialValue = getUseTips();
        if (initialValue !== showTips) {
            localStorage.setItem(USE_TIPS, showTips);
            //window.location.reload();
        }
    }, [showTips]);

    return [showTips, setShowTips];
};